import { render, staticRenderFns } from "./Scanners.vue?vue&type=template&id=3d80b56a&scoped=true"
import script from "./Scanners.vue?vue&type=script&lang=js"
export * from "./Scanners.vue?vue&type=script&lang=js"
import style0 from "./Scanners.vue?vue&type=style&index=0&id=3d80b56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80b56a",
  null
  
)

export default component.exports